/**
 * Assets del producto DPS44 · Acro Yoga Class Ready.
 *
 * MAIN_MOCKUP_URL: mockup principal (hero y recuadro de precio). Todavía no
 * hay mockups del producto: con el string vacío se muestra un abanico con
 * tres páginas reales del Volumen 4. Cuando esté el mockup, pegá su URL acá.
 */
export const MAIN_MOCKUP_URL =
  'https://cdn.magicpatterns.com/uploads/xq9Ekh9MbqHyGrkwN9sRmf/Photorealistic-product-mockup-acro-yoga.png'

/** Páginas reales del Volumen 4 (Gamma), formato 9:16. */
export const PAGE_IMAGES = {
  cover:
    'https://cdn.gamma.app/l3kmqaoww92vn95/generated-images/STn-Dpjs79E5FBPt.jpg',
  howTo:
    'https://cdn.gamma.app/l3kmqaoww92vn95/generated-images/Hv4Qv3koz7l3J2fo.jpg',
  formula:
    'https://cdn.gamma.app/l3kmqaoww92vn95/generated-images/y92d8N4tHDTx8zy5.jpg',
  sessionCard:
    'https://cdn.gamma.app/l3kmqaoww92vn95/generated-images/3usv0ICQ8st7EuhM.jpg',
  threeLane:
    'https://cdn.gamma.app/l3kmqaoww92vn95/generated-images/966QSze_tvKHvv4o.jpg',
  drill:
    'https://cdn.gamma.app/l3kmqaoww92vn95/generated-images/u30e0-uAu_TgG9il.jpg',
  readinessGate:
    'https://cdn.gamma.app/l3kmqaoww92vn95/generated-images/UH1Lgeprh7lJuQ6H.jpg',
  mixedRoom:
    'https://cdn.gamma.app/l3kmqaoww92vn95/generated-images/FF3Ya-PWzw6cRdoe.jpg',
  worksheet:
    'https://cdn.gamma.app/l3kmqaoww92vn95/generated-images/SDyMyQYioPPsA7kZ.jpg',
}
